'use client';

import { c as _c } from "react/compiler-runtime";
import { useSearchParams } from 'next/navigation';
import { parseUA } from '@/helpers/ua-parser';
import { DummyView } from '@/components/system/dummy-view';
const isHeadless = () => navigator.webdriver || parseUA(navigator.userAgent).device === 'bot';

// Vercel's OG-image/link-preview crawler runs a real headless Chrome that
// executes our JS like any visitor — without this gate it would silently
// trigger real writes (account provisioning, redirects) on every deploy or
// share. Sits right before AuthProvider so bots never reach it.
// `?forceBot=1` lets /playground preview this branch from inside an iframe
// without needing an actual headless session.
export const HeadlessGuard = t0 => {
  const $ = _c(1);
  const {
    children
  } = t0;
  const searchParams = useSearchParams();
  if (searchParams.get("forceBot") === "1" || isHeadless()) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <DummyView />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  return children;
};